<template>
  <div
    @wheel.prevent="onWheel"
    @mousedown="startDrag"
    @mousemove="onDrag"
    @mouseup="endDrag"
    @mouseleave="endDrag"
    @dblclick="reset"
  >
    <img
      :src="src"
      :alt="alt"
      draggable="false"
      :style="{
        transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
        transformOrigin: 'center center',
        transition: dragging ? 'none' : 'transform 0.2s ease-out',
        cursor: dragging ? 'grabbing' : 'grab',
        maxWidth: '100%'
      }"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  src: String,
  alt: {
    type: String,
    default: '',
  },
})

const scale = ref(1)
const position = ref({ x: 0, y: 0 })

const dragging = ref(false)
const lastMouse = ref({ x: 0, y: 0 })

const onWheel = (e) => {
  const zoomAmount = 0.1
  scale.value += e.deltaY < 0 ? zoomAmount : -zoomAmount
  scale.value = Math.min(Math.max(scale.value, 0.5), 3) // 최소 0.5배, 최대 3배
}

const startDrag = (e) => {
  dragging.value = true
  lastMouse.value = { x: e.clientX, y: e.clientY }
}

const onDrag = (e) => {
  if (!dragging.value) return
  const dx = e.clientX - lastMouse.value.x
  const dy = e.clientY - lastMouse.value.y
  position.value.x += dx
  position.value.y += dy
  lastMouse.value = { x: e.clientX, y: e.clientY }
}

const endDrag = () => {
  dragging.value = false
}

const reset = () => {
  scale.value = 1
  position.value = { x: 0, y: 0 }
}
</script>

<style scoped>
img {
  user-select: none;
  pointer-events: none;
}
</style>
